import { Component, OnInit, DoCheck } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';

import { AuthService } from 'src/app/services/auth.service';
import { saveAs } from 'file-saver';
import { TimeZoneConverter } from "@shared/pipes/timezone-converter";
import { DatePipe } from '@angular/common';
import { QbExtractorModel } from '@models/qb-extractor.model';
import { QbExtractorService } from '@services/qb-extractor.service';
import { AppConfig } from '@appconfig';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-qb-extractor',
  templateUrl: './qb-extractor.component.html',
  styleUrls: ['./qb-extractor.component.scss'],
  providers: [QbExtractorService,DatePipe]
})
export class QbExtractorComponent implements OnInit {

  //#region Variable Declarations
  public qbExtrForm: FormGroup;
  public showBodyLoader: boolean = false;
  public qbExtrModel: QbExtractorModel;
  public companyId: string;
  //#endregion

  //#region Constructor
  constructor(
      private frmbuilder: FormBuilder,
      private qbService: QbExtractorService,
      private auth: AuthService,
      private datePipe: DatePipe,
      private appConfig: AppConfig,
      private route: ActivatedRoute,
      public timezoneconvertor: TimeZoneConverter) {
        this.route.queryParamMap.subscribe((params) => {
            params.keys.forEach(key => {
                let param = params.get(key);
                if (key === 'CompanyID') {
                    this.companyId = param;
                } else {
                    param = `${key}=${param}`;
                    qbService.token = (qbService.token)? qbService.token + "&" + param: param;
                }
            })
        });
        const isFsExtractor = this.route.snapshot.data['orgFrom'] === 'fs'? true: false;
        if (isFsExtractor) {
            this.companyId = this.auth.getCompanyId();
            this.qbService.token = this.auth.getToken();
        }
        this.CreateForm();
  }
  //#endregion

  //#region Lifecycle Events
  ngOnInit() {
      if (this.qbExtrModel == null)
          this.qbExtrModel = new QbExtractorModel();
      this.qbExtrModel.AccountingName = "No Setup";
      this.qbExtrModel.AccountingType = "No Setup";
      this.qbExtrModel.HasUrl = false;
      this.qbExtrModel.LastExtractDateTime = "";
      this.qbExtrModel.LastExtractStatus = "None";
      this.qbExtrModel.UrlContent = this.appConfig.getEndPoints().ExtractorStorageUrl + "/exportimportemplates/Template_Customer.xlsx";
  }
  //#endregion

  //#region Methods
  private CreateForm() {
      this.showBodyLoader = true;
      if (this.qbExtrModel == null)
          this.qbExtrModel = new QbExtractorModel();
      this.qbExtrModel.DisplayContent = "Previously";
      if (this.qbExtrModel == null)
          this.qbExtrModel = new QbExtractorModel();
      this.qbExtrForm = this.frmbuilder.group({
          "customerID": new FormControl(this.companyId),
          "entityType": new FormControl("", [Validators.required, this.qbService.noWhitespaceValidator])
      });
      this.GetQBDetail();
  }

  public GetQBDetail() {
      this.qbService.GetQBDetail(this.companyId).subscribe(response => {
          this.ProcessResponse(response, false);
      });        
  }

  private GetSubmittedQBDetail() {
      this.qbService.GetSubmittedQBDetail(this.companyId).subscribe(response => {
          this.ProcessResponse(response, true);
      });
  }

  private ProcessResponse(response: any, isSubmitted) {
      if (this.qbExtrModel == null)
          this.qbExtrModel = new QbExtractorModel();

      if (response != null) {
          this.qbExtrModel.AccountingName = (response.IntegrationType != undefined && response.IntegrationType.Code != undefined) ? response.IntegrationType.Code + " Setup" : "None";
          this.qbExtrModel.AccountingType = (response.IntegrationType != undefined && response.IntegrationType.Code != undefined) ? "QB " + response.IntegrationType.Code : "None";
          this.qbExtrModel.HasUrl = response.AttachmentPath != null && response.AttachmentPath.length > 0 ? true : false;
          this.qbExtrModel.UrlContent = this.appConfig.getEndPoints().ExtractorStorageUrl + "/qbextract/" + response.AttachmentPath;
          if(response.ModifyDate.indexOf('Z') != -1) {
            response.ModifyDate = response.ModifyDate.slice(0, response.ModifyDate.length-1);
          }
          this.qbExtrModel.LastExtractDateTime = (this.datePipe.transform(this.timezoneconvertor.transform(response.ModifyDate, false), "MM/dd/yyyy hh:mm a"));
          this.qbExtrModel.LastExtractStatus = response.Status.Name;
      }      
      if (isSubmitted) {
          (async () => {              
              await this.delay(10000);              
              this.showBodyLoader = false;
          })();
      }
      else {
          this.showBodyLoader = false;
      }
  }

  public DownloadAttachment() {
      saveAs(this.qbExtrModel.UrlContent, "QBCutsomer_" + new Date().getTime() + ".xlsx");
  }

  public OnSubmit() {
      if (this.qbExtrForm.valid) {
          this.showBodyLoader = true;
          this.qbExtrModel.DisplayContent = "Currently";
          this.GetSubmittedQBDetail();
      }
      else {
          this.qbService.markFormGroupTouched(this.qbExtrForm)
      }
  }

  delay(ms: number) {
      return new Promise(resolve => setTimeout(resolve, ms));
  }
  //#endregion
}
